export type SessionStoragePort = {
  getItem(key: string): Promise<string | null>;
  setItem(key: string, value: string | null): Promise<void>;
};

export const SESSION_KEY = 'cevop.session';
export const ADMIN_SESSION_KEY = 'cevop.admin.session';

let accessToken: string | null = null;
let adminTokenCache: string | null = null;
let onAuthExpired: (() => void) | null = null;
let sessionPort: SessionStoragePort = createBrowserSessionPort();
let hydrated = false;

function createBrowserSessionPort(): SessionStoragePort {
  return {
    async getItem(key) {
      try {
        return sessionStorage.getItem(key);
      } catch {
        return null;
      }
    },
    async setItem(key, _value) {
      try {
        sessionStorage.removeItem(key);
      } catch {
        /* private mode / non-browser */
      }
    },
  };
}

export function configureSessionStorage(port: SessionStoragePort): void {
  sessionPort = port;
  hydrated = false;
}

export async function hydrateSessionTokens(): Promise<void> {
  accessToken = await sessionPort.getItem(SESSION_KEY);
  adminTokenCache = await sessionPort.getItem(ADMIN_SESSION_KEY);
  hydrated = true;
}

export async function ensureSessionHydrated(): Promise<void> {
  if (!hydrated) {
    await hydrateSessionTokens();
  }
}

export const setAccessToken = (token: string | null) => {
  accessToken = token;
  void sessionPort.setItem(SESSION_KEY, token);
};

export const getAccessToken = () => accessToken;

export const setAdminAccessToken = (token: string | null) => {
  adminTokenCache = token;
  void sessionPort.setItem(ADMIN_SESSION_KEY, token);
};

export const getAdminAccessToken = () => adminTokenCache;

export const setOnAuthExpired = (fn: (() => void) | null) => {
  onAuthExpired = fn;
};

export const notifyAuthExpired = () => {
  onAuthExpired?.();
};
